import { render, staticRenderFns } from "./TreatmentProductOptions.vue?vue&type=template&id=195d6d7e&scoped=true"
import script from "./TreatmentProductOptions.vue?vue&type=script&lang=js"
export * from "./TreatmentProductOptions.vue?vue&type=script&lang=js"
import style0 from "./TreatmentProductOptions.vue?vue&type=style&index=0&id=195d6d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d6d7e",
  null
  
)

export default component.exports